import { ApiId } from "@app/models";
import { DiveJob } from "@app/models";
import { createEntityAdapter, EntityAdapter, EntityState } from "@ngrx/entity";
import { createReducer, on } from "@ngrx/store";
import { StateStatus } from "../model";
import { DiveJobApiActions } from "./actions";

export interface DiveJobState extends EntityState<DiveJob> {
  selectedId: ApiId;
  error: string;
  filter: string;
  status: StateStatus;
}

export const adapter: EntityAdapter<DiveJob> = createEntityAdapter<DiveJob>({
  selectId: (diveJob: DiveJob) => diveJob.id,
  sortComparer: false,
});

export const initialState: DiveJobState = adapter.getInitialState({
  selectedId: null,
  error: null,
  filter: null,
  status: StateStatus.Pending,
});

export const diveJobReducer = createReducer(
  initialState,

  on(DiveJobApiActions.searchDiveJobs, (state) => ({
    ...state,
    status: StateStatus.Loading,
    error: null,
  })),

  on(DiveJobApiActions.searchDiveJobsSuccess, (state, { diveJobs }) =>
    adapter.setAll(diveJobs, {
      ...state,
      status: StateStatus.Success,
      error: null,
    })
  ),

  on(DiveJobApiActions.searchDiveJobsFailure, (state, { error }) => ({
    ...state,
    status: StateStatus.Error,
    error: error,
  }))
);

export const selectId = (state: DiveJobState) => state.selectedId;

export const selectFilter = (state: DiveJobState) => state.filter;
